import { EXTEND_VISIBILITY_LABEL } from "../../../lms-admin-impl/i18n/extendVisibilityLabel.i18n";

export const VISIBILITY_LABEL: { [key: string]: string } = {
	visibility_label: "Sichtbarkeit",
	...EXTEND_VISIBILITY_LABEL,
};
